import { Box, Text } from "grommet";

interface Props {
  number: number;
}
const RankNumber = (props: Props) => {
  const { number } = props;
  let suffix = "";
  switch (number) {
    case 1:
      suffix = "st";
      break;
    case 2:
      suffix = "nd";
      break;
    case 3:
      suffix = "rd";
      break;
    default:
      suffix = "th";
  }
  return (
    <Box direction="row">
      <Box>{number}</Box>
      <Box justify="start">
        <Text size="xsmall">{suffix}</Text>
      </Box>
    </Box>
  );
};

export default RankNumber;
